import { createReducer } from 'redux-act';
import { SSO_AUTH_METHOD } from 'config/constants';
import { updateFetchBookingAuthProcess, updateAuthMethod, setAuthToSSO, setIsSSOLoginScreenVisible } from './actions';
import { initialState as sbaAuthInitialState, reducerBranches as sbaReducerBranches } from './sba/reducer';
import { initialState as ssoAuthInitialState, reducerBranches as ssoReducerBranches } from './sso/reducer';

const initialState = {
  hasFetchedBookingAuthMethod: false,
  isSSOLoginScreenVisible: false,
  authMethod: null,
  sbaUser: sbaAuthInitialState,
  ssoUser: ssoAuthInitialState,
};

const authenticationReducer = createReducer(
  {
    [updateFetchBookingAuthProcess]: (state, payload) => ({
      ...state,
      hasFetchedBookingAuthMethod: !!payload.done,
    }),
    [updateAuthMethod]: (state, payload) => ({
      ...state,
      authMethod: payload.authMethod,
    }),
    [setAuthToSSO]: (state) => ({
      ...state,
      authMethod: SSO_AUTH_METHOD,
      hasFetchedBookingAuthMethod: true,
    }),
    [setIsSSOLoginScreenVisible]: (state, payload) => ({
      ...state,
      isSSOLoginScreenVisible: payload,
    }),
    ...sbaReducerBranches,
    ...ssoReducerBranches,
  },
  initialState,
);

export default authenticationReducer;
